export const namespace = 'machineCategories';

export const MutationTypes = {
  SET_MACHINE_CATEGORIES: 'SET_MACHINE_CATEGORIES',
};

export const ActionTypes = {
  GET_MACHINE_CATEGORIES: 'GET_MACHINE_CATEGORIES',
};
